import React, { useEffect, useState } from "react";

import { BlogsService } from "../../../APIs/index";

import { Blog } from "../../../@types/productInfo";

import BlogTable from "./BlogTable/BlogTable";
import HeaderTable from "../HeaderTable/HeaderTable";
import { Modal } from "antd";
import { useNotification } from "../../Toast/Notification";
import { usePagination } from "../../../hooks/use-pagination";
import useSearchItem from "../../../hooks/use-search-item";

const Blogs: React.FC = () => {
  const [blogs, setBlogs] = useState<Blog[]>([]);

  const [loading] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const { notify } = useNotification();
  const productsPerPage = 5;

  const [selectedRole, setSelectedRole] = useState("all");
  const [filteredBlogs, setFilteredBlogs] = useState<Blog[]>([]);

  const fetchBlogData = async () => {
    try {
      const { data, error } = await BlogsService.getAllBlogs();

      if (data) {
        setBlogs(data);
        setFilteredBlogs(data);
      } else {
        console.error("Error fetching blogs:", error);
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  useEffect(() => {
    fetchBlogData();
  }, []);

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  const filterProductsFromSearch = useSearchItem({
    items: blogs,
    searchTerm,
    selectedRole,
    searchFields: ["name", "blogText", "title"],
  });

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const totalPages = Math.ceil(filteredBlogs.length / productsPerPage);
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = filteredBlogs.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );

  const pageNumbers = usePagination(totalPages);

  useEffect(() => {
    if (searchTerm.length > 0) {
    } else {
      setFilteredBlogs(blogs);
    }
  }, [blogs, filterProductsFromSearch, searchTerm]);

  const handleRoleChange = (event: any) => {
    setSelectedRole(event.target.value);
  };

  const deleteBlog = async (blogId: number) => {
    Modal.confirm({
      title: "Are you sure you want to delete this blog?",
      content: "This action cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        try {
          if (!blogId) {
            console.error("Invalid blog ID");
            return;
          }

          const { data, error } = await BlogsService.deleteBlog(blogId);

          if (data) {
            notify("Blog deleted successfully", "success");
            fetchBlogData();
          } else {
            console.error("Error deleting blog:", error);
            notify("Failed to delete blog", "error");
          }
        } catch (err) {
          console.error("Unexpected error deleting blog:", err);
          notify("An error occurred while deleting the blog", "error");
        }
      },
    });
  };

  return (
    <div className="p-6 rounded-md  mx-auto">
      <div className="flex justify-between items-center mb-4">
        <p
          className="mb-[10px] box-border font-semibold text-[rgb(0,34,56)] block  text-[35px]  text-left h-[38px]
       leading-[38.4px] ">
          Blogs
        </p>
      </div>

      <div className="bg-white p-4 rounded-md w-5/4 mx-auto">
        <HeaderTable
          subtitle="Manage Blogs"
          link="/dashboard/addblog"
          linkText=" Add New Blog"
          inputPlaceholder="Search Blog"
          selectPlaceholder="Filter By Product Type"
          loading={false}
          searchTerm={searchTerm}
          // selectedValue={selectedRole}
          onSearchChange={handleSearchChange}
          onSelectChange={handleRoleChange}
          selectOptions={[
            { value: "flavour", label: "Flavours" },
            { value: "cylinders", label: "Cylinder" },
          ]}
        />

        <BlogTable
          blogs={filteredBlogs}
          loading={loading}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          pageNumbers={pageNumbers}
          currentProducts={currentProducts}
          handleDeleteBlog={deleteBlog}
          // onEditOrder={handleEditClick}
        />
      </div>
    </div>
  );
};

export default Blogs;
